// extracted by mini-css-extract-plugin
export default {"container":"hr-z","heading":"ir-z","text":"jr-z","info":"kr-z","link":"lr-z","fullMaxWidth":"mr-z"};